import { useState } from 'react'
import { ActionBtn } from '@/components/Exporter'
import { useTranslation } from 'react-i18next'
import { getAllBrokers ,assignBrokerToAccountManager} from "@/api/endpoints"
import { useGet, usePost } from '@/api/hooks'
import MultiSelect from '@/components/formFields/DropDown/Multiselect'
import Popup from '@/components/popup'

const SelectACMPopup = ({ modalID, selectedBroker }) => {
    const {t} = useTranslation()
    const [selectedACM, setSelectedACM] = useState(null)
    const { onPost, isLoading } = usePost(assignBrokerToAccountManager)
    const { result: acms, isPending }= useGet({ endPoint: getAllBrokers, allowFetch: true,params: [], depArr: [] })


    const handleChooseACM = () => {
        if (!selectedACM?.value) return;
        onPost({
            brokerId: selectedBroker?.brokerId,
            accountManagerId: selectedACM?.value
        }, onClose)
    }

    const onClose =()=>{
      modalID?.current?.click()
      setSelectedACM(null)
    }
    
  return (
      <Popup needbtn={false} large={false} title={t("select-acm")} name="select-acm-popup" modalID={modalID}>
        <div className='px-4 py-4 w-100'>
            <MultiSelect label="select-acm" className="w-100" isMulti={false} sOptions={selectedACM} setSOptions={setSelectedACM} options={acms} isDisabled={isPending}  />
        </div>
        <ActionBtn title="confirm" className='w-100' onApply={handleChooseACM} isDisabled={isLoading || !selectedACM?.value}/>
    </Popup>
  )
}

export default SelectACMPopup